import { useEffect } from 'react';
import { applyBdsChipExpandableStyles } from '@/core/utils/bdsChipStyles';

/**
 * Custom hook to safely attach close event listeners and apply growth styles
 * to the shadow DOM of custom Blip DS (Bds) chip elements.
 * 
 * Consistent English-only documentation as per repository guidelines.
 */
export function useBdsChip(ref: React.RefObject<unknown>, onRemove: () => void) {
  useEffect(() => {
    const el = ref.current as HTMLElement | null;
    if (!el) return;

    const handleClose = (e: Event) => {
      e.stopPropagation();
      onRemove();
    };

    el.addEventListener('chipClickableClose', handleClose);

    const timeoutId = setTimeout(() => applyBdsChipExpandableStyles(el), 0);

    return () => {
      clearTimeout(timeoutId);
      el.removeEventListener('chipClickableClose', handleClose);
    };
  }, [ref, onRemove]);
}
